import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { StockyEntryService } from '../../services/stocky-entry.service';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { switchMap } from 'rxjs/operators';
import { SetLot } from '../../store/stock-entry.actions';

@Component({
  selector: 'app-create-bag',
  templateUrl: './create-bag.component.html',
  styleUrls: ['./create-bag.component.sass'],
})
export class CreateBagComponent implements OnInit {
  form!: FormGroup;
  selectedFile!: File;
  selectedFileName = '';
  fileImported = false;

  constructor(
    private fb: FormBuilder,
    private stockyEntryService: StockyEntryService,
    private toastr: ToastrService,
    private location: Location,
    private router: Router,
    private store: Store
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      dateBag: [null, Validators.required],
      numberBag: ['', [Validators.required, Validators.maxLength(100)]],
    });
  }

  submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    if (!this.selectedFile) {
      console.error('Selecione um arquivo');
      return;
    }

    const formatedData = new Date(this.form.value.dateBag).toISOString().split('T')[0];

    this.stockyEntryService
      .importBag({
        data: formatedData,
        numeroNota: this.form.value.numberBag,
        file: this.selectedFile,
      })
      .subscribe({
        next: (res) => {
          this.toastr.success('Saca cadastrada com sucesso.');
          this.router.navigate(['tvf/recebimento/lotes']);
        },
        error: (err) => {
          this.toastr.error(err.errors[0] ?? 'Erro ao importar a saca.');
        },
      });
  }

  goBack(): void {
    this.location.back();
  }

  goReceipt(): void {
    if (this.form.invalid || !this.selectedFile) return;

    const formatedData = new Date(this.form.value.dateBag).toISOString().split('T')[0];

    this.stockyEntryService
      .importBag({
        data: formatedData,
        numeroNota: this.form.value.numberBag,
        file: this.selectedFile,
      })
      .pipe(switchMap((res) => this.stockyEntryService.getLots({ Filtro: String(res.numeroLote) })))
      .subscribe({
        next: (getResponse) => {
          const item = getResponse?.page?.[0];
          if (!item) {
            this.toastr.error('Lote não encontrado após importação.');
            return;
          }
          this.store.dispatch(
            new SetLot({
              id: item.id,
              numero: item.numero,
              status: item.status,
              quantityChecked: item.quantidadeItensConferidos,
              totalQuantity: item.totalItens,
              lotDate: new Date(item.dataLote).toLocaleDateString('pt-BR'),
            })
          );
          this.router.navigate(['tvf/recebimento/criar']);
        },
        error: (err) => {
          this.toastr.error(err.errors[0] ?? 'Erro ao importar a saca.');
        },
      });
  }

  onNumericInput(field: string, event: Event): void {
    const input = event.target as HTMLInputElement;
    const cleaned = input.value.replace(/\D/g, '');
    input.value = cleaned;
    this.form.get(field)?.setValue(cleaned, { emitEvent: false });
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    this.selectedFileName = file ? file.name : '';

    if (!file) {
      return;
    }

    const allowedExtensions = ['xlsx', 'xls', 'csv'];

    const extension = file.name.split('.').pop()?.toLowerCase();

    const isValidFile = allowedExtensions.includes(extension || '');

    if (!isValidFile) {
      this.toastr.error('Selecione uma planilha válida.');
      return;
    }

    this.selectedFile = file;
    this.fileImported = true;

    this.toastr.success('Planilha anexada.');
  }
}
